// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
export const ROUTES = {
  home: '/',
  step1: '/step1',
  step2: '/step2',
  step3: '/step3',
  notSupported: '/notSupported',
};

export const SEARCH_PARAMS = {
  page: 'page',
};

export const KNOWN_RESOURCE_FILE = '29375f2f-6a51-42af-86d9-afcf528ee3db.json';

export const ONBOARDING_MESSAGE_NAME = 'at-onboarding-content-script';

export enum OnboardImage {
  STEP1 = 'Step1',
  STEP2 = 'Step2',
  STEP3 = 'Step3',
  STEP4 = 'Step4',
  STEP5 = 'Step5',
}

export enum BrowserType {
  Chrome = 'crios',
  Firefox = 'fxios',
  Safari = 'safari',
  SafariMobile = 'ios',
}
